import React from "react";

import { PeriodSelector } from "../../../../components/src/PeriodSelector";

interface PerformancePeriodSelectorProps {
    firstAvailableStartDate: string;
    endDate?: string;
    defaultStartDate?: string;
}

export const PerformancePeriodSelector = ({
    firstAvailableStartDate,
    endDate,
    defaultStartDate
}: PerformancePeriodSelectorProps): React.ReactElement => {
    return (
        <PeriodSelector
            firstAvailableStartDate={firstAvailableStartDate}
            defaultEndDate={endDate}
            defaultStartDate={defaultStartDate}
        />
    );
};
